(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-product-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-product-carousel')) {
    class CustomProductCarousel extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.track = this.querySelector('[data-cpc-track]');
        this.viewport = this.querySelector('.cpc__viewport');
        this.status = this.querySelector('[data-cpc-status]');
        this.previousButton = this.querySelector('[data-cpc-previous]');
        this.nextButton = this.querySelector('[data-cpc-next]');
        this.originals = Array.from(this.querySelectorAll('[data-cpc-original]'));
        this.count = this.originals.length;
        this.currentIndex = 0;
        this.startIndex = 0;
        this.currentTranslate = 0;
        this.isMoving = false;
        this.isDragging = false;
        this.wasDragged = false;
        this.pauseReasons = new Set();
        this.autoplayEnabled = this.dataset.autoplay === 'true' && this.count > 1;
        this.interval = Math.max(Number(this.dataset.interval) || 5000, 3000);
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.abortController = new AbortController();
        this.signal = this.abortController.signal;

        this.originals.forEach((slide, index) => {
          slide.dataset.cpcIndex = index;
        });

        if (this.count > 1) this.createLoopClones();

        this.slides = Array.from(this.track.children);
        this.currentIndex = this.startIndex;
        this.classList.add('is-ready');

        if (this.previousButton) this.previousButton.hidden = this.count <= 1;
        if (this.nextButton) this.nextButton.hidden = this.count <= 1;

        this.bindEvents();
        this.resizeObserver = new ResizeObserver(() => this.layout(true));
        this.resizeObserver.observe(this.viewport);
        this.layout(true);
        this.scheduleAutoplay();
      }

      disconnectedCallback() {
        if (!this.initialized) return;

        this.clearAutoplay();
        clearTimeout(this.transitionFallback);
        this.abortController.abort();
        this.resizeObserver.disconnect();
        this.querySelectorAll('[data-cpc-clone]').forEach((clone) => clone.remove());
        this.originals.forEach((slide) => {
          slide.removeAttribute('aria-current');
          slide.removeAttribute('tabindex');
        });
        this.classList.remove('is-ready', 'is-dragging');
        this.initialized = false;
      }

      createLoopClones() {
        const before = document.createDocumentFragment();
        const after = document.createDocumentFragment();

        this.originals.forEach((slide) => before.append(this.createClone(slide)));
        this.originals.forEach((slide) => after.append(this.createClone(slide)));

        this.track.prepend(before);
        this.track.append(after);
        this.startIndex = this.count;
      }

      createClone(slide) {
        const clone = slide.cloneNode(true);
        clone.dataset.cpcClone = '';
        clone.removeAttribute('data-cpc-original');
        clone.removeAttribute('aria-current');
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('tabindex', '-1');
        clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
          element.setAttribute('tabindex', '-1');
        });
        return clone;
      }

      bindEvents() {
        this.previousButton?.addEventListener('click', () => this.navigate(-1, true), { signal: this.signal });
        this.nextButton?.addEventListener('click', () => this.navigate(1, true), { signal: this.signal });
        this.track.addEventListener('transitionend', (event) => {
          if (event.target === this.track && event.propertyName === 'transform') this.finishTransition();
        }, { signal: this.signal });
        this.track.addEventListener('pointerdown', (event) => this.startDrag(event), { signal: this.signal });
        this.track.addEventListener('pointermove', (event) => this.drag(event), { signal: this.signal });
        this.track.addEventListener('pointerup', (event) => this.endDrag(event), { signal: this.signal });
        this.track.addEventListener('pointercancel', (event) => this.endDrag(event, true), { signal: this.signal });
        this.track.addEventListener('click', (event) => {
          if (!this.wasDragged) return;
          event.preventDefault();
          event.stopPropagation();
          this.wasDragged = false;
        }, { capture: true, signal: this.signal });
        this.addEventListener('mouseenter', () => this.pause('hover'), { signal: this.signal });
        this.addEventListener('mouseleave', () => this.resume('hover'), { signal: this.signal });
        this.addEventListener('focusin', (event) => {
          if (event.target.matches(':focus-visible')) this.pause('focus');
        }, { signal: this.signal });
        this.addEventListener('focusout', () => {
          requestAnimationFrame(() => {
            if (!this.contains(document.activeElement)) this.resume('focus');
          });
        }, { signal: this.signal });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this.clearAutoplay();
          } else {
            this.scheduleAutoplay();
          }
        }, { signal: this.signal });
        this.reducedMotion.addEventListener('change', () => this.scheduleAutoplay(), { signal: this.signal });
      }

      layout(instant = false) {
        if (!this.viewport.clientWidth || !this.slides.length) return;

        const visibleCount = window.matchMedia('(max-width: 749px)').matches ? 2 : 4;
        this.slideWidth = this.viewport.clientWidth / visibleCount;
        this.style.setProperty('--cpc-slide-width', `${this.slideWidth}px`);
        this.setPosition(instant);
        this.updateActiveSlide();
      }

      setPosition(instant = false) {
        this.currentTranslate = (this.viewport.clientWidth - this.slideWidth) / 2 - (this.currentIndex * this.slideWidth);

        if (instant) this.track.style.transition = 'none';
        this.track.style.transform = `translate3d(${this.currentTranslate}px, 0, 0)`;

        if (instant) {
          this.track.getBoundingClientRect();
          this.track.style.removeProperty('transition');
        }
      }

      navigate(direction, userInitiated = false) {
        if (userInitiated) this.clearAutoplay();
        if (this.isMoving || this.isDragging || this.count <= 1) return;

        this.currentIndex += direction;
        this.isMoving = true;
        this.shouldAnnounce = userInitiated;
        this.setControlsBusy(true);
        this.updateActiveSlide();
        this.setPosition(false);

        clearTimeout(this.transitionFallback);
        this.transitionFallback = setTimeout(() => this.finishTransition(), 700);

        if (this.reducedMotion.matches) requestAnimationFrame(() => this.finishTransition());
      }

      finishTransition() {
        if (!this.isMoving) return;

        clearTimeout(this.transitionFallback);
        this.isMoving = false;
        let normalized = false;

        if (this.currentIndex >= this.startIndex + this.count) {
          this.currentIndex -= this.count;
          normalized = true;
        } else if (this.currentIndex < this.startIndex) {
          this.currentIndex += this.count;
          normalized = true;
        }

        if (normalized) this.setPosition(true);
        this.updateActiveSlide();
        this.setControlsBusy(false);

        if (this.shouldAnnounce) this.announceCurrentSlide();
        this.shouldAnnounce = false;
        this.scheduleAutoplay();
      }

      updateActiveSlide() {
        const activeProductIndex = this.getActiveProductIndex();

        this.slides.forEach((slide, index) => {
          slide.classList.toggle('is-active', index === this.currentIndex);
        });

        this.originals.forEach((slide, index) => {
          const active = index === activeProductIndex;
          slide.toggleAttribute('aria-current', active);
          if (slide.matches('a')) slide.tabIndex = active ? 0 : -1;
        });
      }

      getActiveProductIndex() {
        return ((this.currentIndex - this.startIndex) % this.count + this.count) % this.count;
      }

      announceCurrentSlide() {
        if (!this.status) return;

        const index = this.getActiveProductIndex();
        const title = this.originals[index]?.dataset.title || '';
        this.status.textContent = `${index + 1} / ${this.count} · ${title}`;
      }

      setControlsBusy(busy) {
        [this.previousButton, this.nextButton].forEach((button) => {
          if (button) button.setAttribute('aria-disabled', String(busy));
        });
      }

      startDrag(event) {
        if (event.button !== 0 || this.isMoving || this.count <= 1) return;

        this.isDragging = true;
        this.wasDragged = false;
        this.dragStartX = event.clientX;
        this.dragStartTranslate = this.currentTranslate;
        this.pause('drag');
        this.classList.add('is-dragging');
        this.track.setPointerCapture(event.pointerId);
      }

      drag(event) {
        if (!this.isDragging) return;

        const distance = event.clientX - this.dragStartX;
        if (Math.abs(distance) > 6) this.wasDragged = true;
        this.currentTranslate = this.dragStartTranslate + distance;
        this.track.style.transform = `translate3d(${this.currentTranslate}px, 0, 0)`;
      }

      endDrag(event, cancelled = false) {
        if (!this.isDragging) return;

        const distance = event.clientX - this.dragStartX;
        const threshold = Math.min(64, this.slideWidth * 0.18);
        const changedSlide = !cancelled && Math.abs(distance) >= threshold;
        this.isDragging = false;
        this.classList.remove('is-dragging');

        if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);

        if (changedSlide) {
          this.navigate(distance < 0 ? 1 : -1, true);
        } else if (this.wasDragged) {
          this.isMoving = true;
          this.setControlsBusy(true);
          this.setPosition(false);
          clearTimeout(this.transitionFallback);
          this.transitionFallback = setTimeout(() => this.finishTransition(), 700);
          if (this.reducedMotion.matches) requestAnimationFrame(() => this.finishTransition());
        } else {
          this.track.style.removeProperty('transition');
        }

        this.resume('drag');
        if (this.wasDragged) setTimeout(() => { this.wasDragged = false; }, 0);
      }

      pause(reason) {
        this.pauseReasons.add(reason);
        this.clearAutoplay();
      }

      resume(reason) {
        this.pauseReasons.delete(reason);
        this.scheduleAutoplay();
      }

      clearAutoplay() {
        clearTimeout(this.autoplayTimer);
        this.autoplayTimer = null;
      }

      scheduleAutoplay() {
        this.clearAutoplay();

        if (
          !this.autoplayEnabled ||
          this.pauseReasons.size > 0 ||
          this.isMoving ||
          this.isDragging ||
          document.hidden ||
          this.reducedMotion.matches
        ) return;

        this.autoplayTimer = setTimeout(() => this.navigate(1), this.interval);
      }
    }

    customElements.define('custom-product-carousel', CustomProductCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
